import { render, staticRenderFns } from "./NewTarget.vue?vue&type=template&id=3b676980&scoped=true"
import script from "./NewTarget.vue?vue&type=script&lang=js"
export * from "./NewTarget.vue?vue&type=script&lang=js"
import style0 from "./NewTarget.vue?vue&type=style&index=0&id=3b676980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b676980",
  null
  
)

export default component.exports